/** `compile` brands its result with this non-enumerable key, which no JSON value can carry. */
export const COMPILED_BRAND = Symbol.for('codex.calendar.compiled');
export const MOON_PHASE_NAMES = [
    'new',
    'waxing_crescent',
    'first_quarter',
    'waxing_gibbous',
    'full',
    'waning_gibbous',
    'last_quarter',
    'waning_crescent',
];
/** True for a calendar `compile` built (by any copy of this module). */
export function isCompiled(value) {
    return (typeof value === 'object' &&
        value !== null &&
        value[COMPILED_BRAND] === true);
}
//# sourceMappingURL=types.js.map